import { render, staticRenderFns } from "./DevelopmentValidation.vue?vue&type=template&id=20c17e92&"
import script from "./DevelopmentValidation.ts?vue&type=script&lang=ts&"
export * from "./DevelopmentValidation.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports